const ANALYTICS_KEY = '__rhAnalytics';
const ANALYTICS_ATTRIBUTE_NAME = 'rh-analytics';

export {
    ANALYTICS_KEY,
    ANALYTICS_ATTRIBUTE_NAME,
};
